export default {
  name: 'NrProgress',
  props: {
    max: {
      type: Number,
      default: 100
    },
    value: {
      type: Number,
      default: undefined
    }
  }
};